var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"accordion",class:{open : _vm.open},on:{"click":_vm.toggleItem}},[_c('h2',{staticClass:"title"},[_vm._t("title")],2)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }